import { useArchiveEditingVisuals } from 'dataQueries'

import constate from 'constate'

export const [VisualsEditingDownloadProvider, useVisualsEditingDownload] = constate(() => {
  const archiveEditingVisualsMutation = useArchiveEditingVisuals()

  const downloadUrl = archiveEditingVisualsMutation.data?.url
  const hasDownloadFailed = archiveEditingVisualsMutation.isError
  const isDownloadReady = archiveEditingVisualsMutation.isSuccess
  const isDownloadRunning = archiveEditingVisualsMutation.isPending

  return {
    archiveEditingVisualsMutation,
    downloadUrl,
    hasDownloadFailed,
    isDownloadReady,
    isDownloadRunning,
  }
})
